import { useWorkspace } from '@/composables/useWorkspace';
import { getLandingsApiRequest } from '@/services/api/landings-api';
import { useStore } from '@/store';

export const populateLandingsStoreCacheApiRequest = async () => {
  const store = useStore();
  const payload = await getLandingsApiRequest({
    status: 'active',
    limit: '200',
    columns: ['id', 'name', 'nameFull', 'countryId', 'workspaceId', 'offers', 'url'],
    tagsOff: 1,
    orderBy: 'updated',
    orderDirection: 'desc',
  });
  store.cache.populateLandingsCache(payload);
  return payload;
};

export const updateLandingsStoreCacheApiRequest = async ({
  workspaceId,
  countryId,
}: {
  workspaceId: string;
  countryId: number;
}) => {
  const store = useStore();
  const workspaceApi = useWorkspace();
  const payload = await getLandingsApiRequest({
    status: 'active',
    limit: '200',
    columns: ['id', 'name', 'nameFull', 'countryId', 'workspaceId', 'offers', 'url'],
    tagsOff: 1,
    orderBy: 'updated',
    orderDirection: 'desc',
    workspaceIds: [...new Set([workspaceId, ...workspaceApi.allPublicWorkspacesIds.value])],
    ...(countryId !== 0 && { countryId }),
  });
  store.cache.updateLandingsCache({
    workspaceId,
    countryId,
    data: payload,
  });
  return payload;
};
